import React from "react";
import { Header, Divider, Container, Grid } from "semantic-ui-react";
const Text = () => (
  <div className="iframe-container iframe-container-9by16">
    <iframe
      title="Class cloud description"
      src="https://docs.google.com/document/d/e/2PACX-1vTS27DFI3YJmThN60jvb2PV4Td5uJgYJaFTSo6yTIQ-kWtWz283BTFtLZ7E4d7Lp-rb7b6JTvpsspvK/pub?embedded=true"
    />
  </div>
);
export const class_cloud = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>Class cloud</Header.Content>
        <Header.Subheader>
          <p>Portable content server for low-income Schools</p>
          <p>
            Credit : Developed with{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/ashish2py/"
            >
              @Ashish,
            </a>{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/rahul-d-souza-2a3a9615/"
            >
              @Rahul,
            </a>{" "}
            and{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/cliffton/"
            >
              @Clifton
            </a>
          </p>
        </Header.Subheader>
        <Divider />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <div className="iframe-container iframe-container-16by9">
                <iframe
                  title="Class cloud video"
                  src="https://www.youtube.com/embed/DpFBPOR6zL8"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Header>
      <Text />
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/class_cloud.js